export default "__VITE_ASSET__BzTFcMa4__"